import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01d9d8f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = {
  class: "row",
  style: {"gap":"5px"}
}
const _hoisted_5 = { class: "col d-flex flex-column justify-content-center align-item-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Control de Despachos")
], -1))
const _hoisted_7 = { class: "card overflow-scroll w-100" }
const _hoisted_8 = { class: "table table-hover table-sm" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", null, "Operador"),
    /*#__PURE__*/_createElementVNode("th", null, "No. Vuelo"),
    /*#__PURE__*/_createElementVNode("th", null, "No. Embarque"),
    /*#__PURE__*/_createElementVNode("th", null, "Destinatario"),
    /*#__PURE__*/_createElementVNode("th", null, "Piezas"),
    /*#__PURE__*/_createElementVNode("th", null, "Peso"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cargos Generados")
], -1))
const _hoisted_12 = {
  class: "card overflow-scroll w-100",
  style: {"height":"150px"}
}
const _hoisted_13 = { class: "table table-hover table-sm" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Cargo"),
    /*#__PURE__*/_createElementVNode("th", null, "Descripción"),
    /*#__PURE__*/_createElementVNode("th", null, "Monto"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado")
  ])
], -1))
const _hoisted_15 = {
  class: "col div-buttom",
  style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px","height":"300px"}
}
const _hoisted_16 = { class: "btn-group2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]

import { ref, onMounted, computed, Ref } from 'vue';
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';
import { Carentre, Cardeent } from '@/interface/interfaces';
import UpConfirma from './pUpdate/UpConfirma.vue';
import UpComplemento from './pUpdate/UpComplemento.vue';
import InDatosE from './pInsert/InDatosE.vue';
import { flattenDiagnosticMessageText } from 'typescript';


export default /*#__PURE__*/_defineComponent({
  __name: 'CtrlDespacho',
  setup(__props) {

 
const {success, error, question,warning} = useAlert()
const dUrl = UrlGlobal()
const search = ref('')
const options = ref('')
const id_ref = ref<string | null>(null)
const de_ref = ref<string | null>(null)
//--------------------------------------------------------------------------------------------------------------
const carentre = ref<Array<Carentre>>([]);

const getCarentre = () => { 
        axios.get(dUrl.urlGlobal +'/api2/carentre/')
            .then(response => {
                carentre.value = response.data;
        
            //let almacen = response.data.almacen
            //let area = response.data.area

            })
            .catch(error => {
                console.error('Error buscando control de despachos:', error);
            });
};
//----------------------------------------------------------------
const cardeent = ref<Array<Cardeent>>([])
const getCardeent = (id_fecha: any, id_fecha_manifiesto: any, id_operador: any, id_numero_vuelo: any, id_no_embarque: any, id: any) => {
        id_ref.value = id_no_embarque
        fecha = id_fecha
        fecha_manifiesto = id_fecha_manifiesto
        operador = id_operador
        numero_vuelo = id_numero_vuelo
        no_embarque = id_no_embarque

        axios.get(`${dUrl.urlGlobal}/api2/carentre/cardeent?id_no_embarque=${no_embarque}&id_numero_vuelo=${numero_vuelo}&id_operador=${operador}
                  &id_fecha_manifiesto=${fecha_manifiesto}&id_fecha=${fecha}`)
        //axios.get(final)    
            .then(response => { //console.log(response.data)
                cardeent.value = response.data;
                console.log(response.data)

                
            })
            .catch((error: any) => {
                console.error('Error buscando detalles de despacho:', error);
        });
    }
//};
//funcion de los botones y las extenciones de Insert,delete,update----------------
let fecha: any
let fecha_manifiesto: any
let operador: any
let numero_vuelo: any
let no_embarque: any

let btnUp = ref(false);//variable para mostrar modal de update
let clickUp = ref(false)//variable para activar el click de Up
let btnCoUp = ref(false)
let clickCoUp = ref(false)

//funciones q activan el click y en el caso del insert muestran el modal
const CbtnUp = () => {
  clickUp.value = !clickUp.value
   
}
function updatePropsValue(newValue: boolean) {
  btnUp.value = newValue
  getCarentre()
  getCardeent("1", "1", "1", "1", "1", "1")
}

function updateCoPropsValue(newValue: boolean) {
  btnCoUp.value = newValue

  getCarentre()
  getCardeent("1", "1", "1", "1", "1", "1")
}

const btnDE = ref(false)
const CbtnDE= () => {
  btnDE.value = !btnDE.value
   
}
function DEPropsValue(newValue: boolean) {
  btnDE.value = newValue
}
//--- Fun//funcion principal para el funcionamiento de el update y delete cuando uno de los 2 este activado
const FunClick = (n: any, nm: any, st: any) => {
  fecha = n;
  operador = nm;
  numero_vuelo = st;

  if (clickUp.value == true) {
    btnUp.value = !btnUp.value
    clickUp.value = !clickUp.value
  }
}
  //-- Funciones de Botones
const Calcular = async() => {
  let calcular = true
  
  const result = await question(
    'Se generarán los calculos de la Guía',
    '¿Seguro desea continuar?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  axios.get(`${dUrl.urlGlobal}/api2/carcmani/calculo?id=${id_ref.value}`) 
    .then(response => {
      console.log("Generado")
      getCarentre
      getCardeent("1", "1", "1", "1", "1", "1")
    })
    .catch(error => {
      console.log('Error calculando:', error)
    })
}


const Complemento = () => {
  clickCoUp.value = !clickCoUp.value

  if (clickCoUp.value == true) {
    btnCoUp.value = !btnCoUp.value
    clickCoUp.value = !clickCoUp.value
  }
}

const Listar = () => {
  let calcular = false
}

const Anular = () => {
  let calcular = false
}

//-----------------------------------------------------------------
// Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos segun la tabla------------------------------------------------
const filteredCarga1 = computed(() => {
    if (search.value === '') {
        // Si no hay nada en la búsqueda, retornar todos los registros
        return carentre.value;
    } else if (options.value == 'fecha') {
        // Convertir el término de búsqueda a minúsculas para hacer la búsqueda insensible a mayúsculas
        const searchTerm = search.value.toLowerCase();
        // Filtrar los registros que coincidan con el valor de búsqueda en cualquiera de los campos
        return carentre.value.filter(elm => {
            return (
                elm.fecha?.toLowerCase().includes(searchTerm) ||
                elm.fecha_manifiesto?.toLocaleLowerCase().includes(searchTerm) ||
                elm.nom_operador?.toLowerCase().includes(searchTerm) ||
                elm.numero_vuelo?.toLowerCase().includes(searchTerm) ||
                elm.destinatario?.toLowerCase().includes(searchTerm) ||
                elm.piezas_entrega?.toLowerCase().includes(searchTerm) ||
                elm.monto?.toLowerCase().includes(searchTerm) ||
                elm.nom_status?.toLowerCase().includes(searchTerm)
            );
        });
    }else{
        return carentre.value
    }
});
//-----------------------------------------------------------------
const filteredCarga2 = computed(() => {
    if (search.value === '') {
        return cardeent.value;

    } else if (options.value == 'Cardeent') {
        const searchTerm = search.value.toLowerCase();

        return cardeent.value.filter(elm1 => {
            return (
                elm1.nom_tarifa?.toLowerCase().includes(searchTerm) ||
                elm1.monto?.toLowerCase().includes(searchTerm) ||
                elm1.nom_status?.toLowerCase().includes(searchTerm) 
            );
        });
    }else{
        return cardeent.value
    }
});

//const FunClick = (fe: any, op: any, nv: any) => {
//  let fecha = fe;
//  let operador = op;
//  let numero_vuelo = nv;
   
//----------------------------------------------------------------
// Estado del formulario y la data
//const formData = ref({
//  base_datos: '',
//  tipo_base_datos: '',
//  servidor_bdatos: '',
//  hostname: '',
//  ip_address: '',
//  servicio: '',
//  puerto: '',
//  protocolo: ''
//});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
const currentIndex = ref(0);
const isEditing = ref(false);
const isSearching = ref(false);
const isInserting = ref(false);
const isDeleting = ref(false);
const canNavigate = ref(false);
const onlyRead = ref(true);
const ButtonText = ref('Conf')
const ButtonText2 = ref('Complto')
const ButtonText3 = ref('Calcula')
const ButtonText4 = ref('Anular')

// Deshabilita los botones de btn-group2 si no está en modo búsqueda o insercion
const canUseGroup2 = computed(() => isSearching.value || isInserting.value || isEditing.value || isDeleting.value);

//boton principal que controla el submit

//------------------------------------------------------------------------------------------------------------------
onMounted(() => {
    getCarentre();
    getCardeent("1", "1", "1", "1", "1", "1");
  
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCarga1.value, (elm) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm.numero_vuelo,
                        onClick: ($event: any) => (getCardeent(elm.fecha, elm.fecha_manifiesto, elm.operador, elm.numero_vuelo, elm.no_embarque, elm.id)),
                        class: _normalizeClass({ 'table-primary': elm.no_embarque === id_ref.value })
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm.fecha_manifiesto), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_operador), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.numero_vuelo), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.no_embarque), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.destinatario), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.piezas_entrega), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.peso), 1),
                        _createElementVNode("td", null, _toDisplayString(elm.nom_status), 1)
                      ], 10, _hoisted_10))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("table", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardeent.value, (elm1) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: elm1.tarifa
                      }, [
                        _createElementVNode("td", null, _toDisplayString(elm1.tarifa), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.nom_tarifa), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.monto), 1),
                        _createElementVNode("td", null, _toDisplayString(elm1.nom_status), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _withModifiers(CbtnDE, ["prevent"])
                }, "Datos Entrega"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Complemento,
                  disabled: ""
                }, "Despacho"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Listar,
                  disabled: !canUseGroup2.value
                }, "Imprimir", 8, _hoisted_17),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: Anular,
                  disabled: !canUseGroup2.value
                }, "Anular", 8, _hoisted_18)
              ])
            ])
          ])
        ]),
        (_unref(btnUp))
          ? (_openBlock(), _createBlock(UpConfirma, {
              key: 0,
              fecha: _unref(fecha),
              operador: _unref(operador),
              numero_vuelo: _unref(numero_vuelo),
              btnUp: _unref(btnUp),
              onUpdateProps: updatePropsValue
            }, null, 8, ["fecha", "operador", "numero_vuelo", "btnUp"]))
          : _createCommentVNode("", true),
        (_unref(btnCoUp))
          ? (_openBlock(), _createBlock(UpComplemento, {
              key: 1,
              fecha: _unref(fecha),
              operador: _unref(operador),
              numero_vuelo: _unref(numero_vuelo),
              btnCoUp: _unref(btnCoUp),
              onUpdateCoProps: updateCoPropsValue
            }, null, 8, ["fecha", "operador", "numero_vuelo", "btnCoUp"]))
          : _createCommentVNode("", true)
      ])
    ]),
    (btnDE.value)
      ? (_openBlock(), _createBlock(InDatosE, {
          key: 0,
          BdatosE: btnDE.value,
          numembarque: _unref(no_embarque),
          onDEpropsValue: DEPropsValue
        }, null, 8, ["BdatosE", "numembarque"]))
      : _createCommentVNode("", true)
  ]))
}
}

})